import styled, { css } from "styled-components";

export const Paragraph = styled.p`
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
`;

export const ParagraphSmall = styled.p`
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 10pt;
`;

export const TableHeader = styled.th`
  text-align: left;
  font-weight: bold;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
  padding: 5px;
`;

export const TableData = styled.td`
  text-align: left;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
  padding: 5px;
`;

export const TableDataRight = styled.td`
  text-align: right;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
  padding: 5px;
`;

export const HlaTableHeader = styled.th`
  text-align: center;
  border: 1px solid #000;
  background-color: lightgrey;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
  padding: 5px;
`;

export const HlaTableData = styled.td`
  text-align: center;
  border: 1px solid #000;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
  padding: 5px;
`;


export const textStyle = css`
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 14pt;
`;



export const ContentWrapperold = styled.div`
  width: 100%;
  min-height: 65vh;
  padding: 0 5px;
  margin-bottom: 5px;
  background-color: #FFF;

  &.compact-form {
    .form-group {
      margin-bottom: 8px; /* not too tight, was 15px */
    }

    .control-label {
      margin-bottom: 2px;
      font-weight: 600;
      font-size: 15px; /* slightly larger than compressed */
      line-height: 1.2;
    }

    .form-control-static {
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 15px;
      line-height: 1.3;
    }

    table {
      margin-bottom: 14px; /* moderate spacing */
      font-size: 14px;     /* readable */
      border-collapse: collapse;
    }

    th,
    td {
      padding: 4px 6px;   /* more breathing room than 2px */
      line-height: 1.2;
    }

    .panel-heading {
      padding: 6px 10px;  /* slightly looser */
      font-size: 14px;
      font-weight: 600;
    }

    .panel-body {
      padding: 10px 12px; /* not as flat as before */
    }

    /* --- HLA-specific table overrides --- */
    .hla-table {
      table-layout: fixed;   /* prevent auto-stretch */
      width: 100%;
      font-size: 14px;       /* smaller text for dense antigen data */
    }

    .hla-table th,
    .hla-table td {
      padding: 2px 4px;
      text-align: center;
      white-space: nowrap;   /* prevent wrapping */
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .hla-table th {
      width: 60px;   /* narrower headers */
    }

    .hla-table td {
      width: 70px;   /* control data cell width */
    }
  }
`;


export const ContentWrapper = styled.div`
  width: 100%;
  min-height: 65vh;
  padding: 0 5px;
  margin-bottom: 5px;
  background-color: #FFF;

  &.compact-form {
    /* --- Recipient Details / Form Groups --- */
    .form-group {
      margin-bottom: 4px; /* tighter spacing between rows */
      display: flex;
      align-items: center;
    }

    .control-label {
      margin-bottom: 0;
      margin-right: 6px; /* space between label and value */
      font-weight: 600;
      font-size: 13px;
      line-height: 1.2;
      width: 90px; /* fixed label width for alignment */
    }

    .form-control-static {
      padding-top: 0;
      padding-bottom: 0;
      font-size: 13px;
      line-height: 1.2;
      margin-left: 4px; /* smaller gap from label */
    }

    /* --- General tables --- */
    table {
      margin-bottom: 12px;
      font-size: 12px;
      border-collapse: collapse;
    }

    th,
    td {
      padding: 4px 6px;
      line-height: 1.2;
    }

    .panel-heading {
      padding: 6px 10px;
      font-size: 14px;
      font-weight: 600;
    }

    .panel-body {
      padding: 8px 10px; /* tighter than before */
    }

    /* --- HLA tables --- */
    .hla-table {
      table-layout: fixed;
      width: 100%;
      font-size: 14px;
    }

    .hla-table th,
    .hla-table td {
      padding: 2px 4px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .hla-table th {
      width: 60px;
    }

    .hla-table td {
      width: 70px;
    }
  }
`;




